import React from 'react';
import { X, Shield, AlertTriangle, Truck, Scale } from 'lucide-react';

export default function TermsModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in">
      <div className="bg-white w-full max-w-2xl h-[80vh] rounded-3xl shadow-2xl relative flex flex-col">
        <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-3xl">
          <button onClick={onClose} className="bg-gray-200 p-2 rounded-full hover:bg-gray-300"><X size={20} /></button>
          <h2 className="text-lg font-black text-gray-800">תקנון ותנאי שימוש</h2>
        </div>

        <div className="p-6 overflow-y-auto text-right flex-1" dir="rtl">
          <h1 className="text-2xl font-black text-gray-900 mb-2">ברוכים הבאים לדרייבר.ישראל</h1>
          <p className="text-gray-500 mb-6 text-sm">אנא קראו בעיון לפני השימוש.</p>

          <div className="space-y-6">
            <section>
              <h3 className="font-bold text-blue-600 flex items-center gap-2"><Shield size={18} /> 1. מהות הפלטפורמה</h3>
              <p className="text-sm text-gray-700 mt-1">דרייבר.ישראל מחברת בין שולחי חבילות לשליחים. הפלטפורמה אינה צד להתקשרות ואינה מעסיקה את השליחים.</p>
            </section>

            <section className="bg-red-50 p-3 rounded-xl border border-red-100">
              <h3 className="font-bold text-red-600 flex items-center gap-2"><AlertTriangle size={18} /> 2. אחריות</h3>
              <ul className="list-disc list-inside text-sm text-gray-800 mt-1 space-y-1">
                <li>השימוש באחריות המשתמש בלבד.</li>
                <li>הפלטפורמה אינה אחראית לאובדן, נזק או איחור בחבילה.</li>
                <li>אסור לשלוח חומרים מסוכנים או פריטים בלתי חוקיים.</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 flex items-center gap-2"><Truck size={18} /> 3. תשלום</h3>
              <p className="text-sm text-gray-700 mt-1">דמי המשלוח משולמים במזומן ישירות בין השולח לשליח. הפלטפורמה אינה גובה עמלות ואינה צד לעסקה הכספית. השליח אחראי לדיווח מס.</p>
            </section>

            <section>
              <h3 className="font-bold text-gray-800 flex items-center gap-2"><Scale size={18} /> 4. ציות לחוק</h3>
              <p className="text-sm text-gray-700 mt-1">השליח מצהיר כי ברשותו רישיון נהיגה וביטוח בתוקף. אנו שומרים את הזכות למסור פרטים לרשויות במקרה של חשד לעבירה.</p>
            </section>
          </div>
        </div>

        <div className="p-4 border-t bg-gray-50 rounded-b-3xl text-center">
          <button onClick={onClose} className="bg-black text-white px-8 py-3 rounded-xl font-bold hover:bg-gray-800 w-full md:w-auto">קראתי והבנתי, סגור</button>
        </div>
      </div>
    </div>
  );
}
